import React from 'react'
import VideosBanner from '../../components/videos/videosBanner'
import Header from '../../shared/header'
import PagesFooter from "../../shared/pagesFooter"
const VideosPage = () => {
    return (
        <div>
            <div className='videos-header'>
                <Header />
            </div>
            <VideosBanner />
            <PagesFooter />
        </div>
    )
}

export default VideosPage